(function (global) {
  'use strict';

  function parsePieces(label) {
    var match = /^Pack of ([1-9]\d*|[1-9]\d{0,2}(?:,\d{3})+)$/.exec(String(label));
    if (!match) return 0;
    var pieces = Number(match[1].replace(/,/g, ''));
    return Number.isSafeInteger(pieces) && pieces % 500 === 0 ? pieces : 0;
  }

  function positiveInteger(value) {
    return /^[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value));
  }

  function formatTemplate(template, values) {
    return template.replace(/__([A-Z]+)__/g, function (_, token) {
      var key = token.toLowerCase();
      if (!(key in values)) throw new Error('Missing bulk-pricing label value: ' + key);
      return String(values[key]);
    });
  }

  function matchingVariants(variants, selected, quantityIndex) {
    return variants.filter(function (variant) {
      return variant.options.every(function (value, index) {
        return index === quantityIndex || value === selected[index];
      });
    });
  }

  function cartBreakdown(item, productConfig) {
    if (!productConfig) return null;
    var option = (item.options_with_values || []).find(function (entry) {
      return entry.name.toLowerCase() === productConfig.quantityOption.toLowerCase();
    });
    var pieces = option ? parsePieces(option.value) : 0;
    if (!pieces || !positiveInteger(item.quantity) || !Number.isSafeInteger(pieces * item.quantity) ||
        !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0) {
      throw new Error('Invalid bulk cart configuration for product ' + item.product_id);
    }
    return {
      pieces: pieces,
      lots: item.quantity,
      totalPieces: pieces * item.quantity,
      unitCents: item.final_line_price / (pieces * item.quantity)
    };
  }

  var api = {
    parsePieces: parsePieces,
    positiveInteger: positiveInteger,
    formatTemplate: formatTemplate,
    matchingVariants: matchingVariants,
    cartBreakdown: cartBreakdown
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document) return;
  if (global.IlikamBulkPricing) return;
  global.IlikamBulkPricing = api;

  var configNode = document.getElementById('IlikamBulkConfig');
  if (!configNode) throw new Error('Bulk pricing configuration is missing.');
  var config = JSON.parse(configNode.textContent);
  var strings = config.strings;
  var numberFormat = new Intl.NumberFormat(config.locale);
  var moneyFormat = new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: config.currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  function money(cents) { return moneyFormat.format(cents / 100); }
  function number(value) { return numberFormat.format(value); }

  api.cartPresentation = function (item) {
    if (global.IlikamUnitPricing) return global.IlikamUnitPricing.cartPresentation(item);
    var breakdown = cartBreakdown(item, config.products[String(item.product_id)]);
    if (!breakdown) return null;
    return {
      unit: money(breakdown.unitCents) + ' ' + strings.perPiece,
      summary: formatTemplate(strings.cartSummary, {
        pieces: number(breakdown.totalPieces), lots: number(breakdown.lots)
      }),
      lotsLabel: formatTemplate(strings.lotLabel, { pieces: number(breakdown.pieces) })
    };
  };

  function initialize(root) {
    if (root.dataset.initialized === 'true') return;
    var form = root.closest('form');
    var data = JSON.parse(root.querySelector('[data-bulk-data]').textContent);
    var quantityIndex = data.options.findIndex(function (name) {
      return name.toLowerCase() === data.quantityOption.toLowerCase();
    });
    var selectors = form ? Array.from(form.querySelectorAll('.single-option-selector')) : [];
    if (!form || quantityIndex < 0 || selectors.length !== data.options.length || !global.jQuery) {
      throw new Error('The bulk pricing selector requires the Savon product form and its option selectors.');
    }
    var $form = global.jQuery(form);
    var quantitySelect = selectors[quantityIndex];
    var variantSelect = form.querySelector('select[name="id"]');
    var priceRoot = document.querySelector('[data-bulk-price-for="' + root.dataset.productId + '"]');
    if (!variantSelect || !priceRoot) throw new Error('Bulk product price or variant input is missing.');
    var tierInputs = Array.from(root.querySelectorAll('[data-bulk-tier]'));
    var lotInput = form.querySelector('[name="quantity"]');
    if (!lotInput) {
      lotInput = document.createElement('input');
      lotInput.type = 'hidden';
      lotInput.name = 'quantity';
      lotInput.value = '1';
      form.appendChild(lotInput);
    }
    var quantityBlock = lotInput.closest('.dt-sc-qty');
    var lotLabel = quantityBlock ? quantityBlock.querySelector('.product-label') : null;
    var errorNode = root.querySelector('[data-bulk-error]');
    var statusNode = root.querySelector('[data-bulk-status]');
    var buttons = Array.from(form.querySelectorAll('[name="add"]'));
    var paymentButton = form.querySelector('.shopify-payment-button');
    var url = new URL(global.location.href);
    var syncing = false;
    var firstSelection = true;

    function changeOption(value) {
      quantitySelect.value = value;
      quantitySelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function synchronize() {
      var selected = selectors.map(function (selector) { return selector.value; });
      var matches = matchingVariants(data.variants, selected, quantityIndex);
      var variant = matches.find(function (entry) { return entry.options[quantityIndex] === quantitySelect.value; });

      if (!variant && !syncing) {
        var replacement = matches.find(function (entry) { return entry.available; });
        if (replacement) {
          syncing = true;
          changeOption(replacement.options[quantityIndex]);
          syncing = false;
          return;
        }
      }

      var baseline = matches.find(function (entry) { return parsePieces(entry.options[quantityIndex]) === 500; });
      tierInputs.forEach(function (input) {
        var pieces = Number(input.value);
        var entry = matches.find(function (candidate) { return parsePieces(candidate.options[quantityIndex]) === pieces; });
        var card = input.nextElementSibling;
        input.checked = Boolean(entry && variant && entry.id === variant.id);
        input.disabled = !entry || !entry.available;
        input.dataset.variantId = entry ? entry.id : '';
        card.querySelector('.bulk-tier-card__heading').textContent = number(pieces) + ' ' + strings.pieces;
        card.querySelector('[data-tier-unit]').textContent = entry ? money(entry.price / pieces) + ' ' + strings.perPiece : '';
        card.querySelector('[data-tier-total]').textContent = entry ? money(entry.price) + ' ' + strings.packTotal : '';
        var availability = card.querySelector('[data-tier-availability]');
        availability.hidden = Boolean(entry && entry.available);
        availability.textContent = entry ? strings.soldOut : strings.unavailable;
        var saving = baseline && entry ? Math.floor((1 - (entry.price / pieces) / (baseline.price / 500)) * 100) : 0;
        var savingNode = card.querySelector('[data-tier-saving]');
        savingNode.hidden = saving <= 0;
        savingNode.textContent = saving > 0 ? formatTemplate(strings.save, { percent: saving }) : '';
      });

      var lotsValid = positiveInteger(lotInput.value);
      var pieces = variant ? parsePieces(variant.options[quantityIndex]) : 0;
      var lots = Number(lotInput.value);
      lotsValid = lotsValid && Number.isSafeInteger(pieces * lots) &&
        Boolean(variant && Number.isSafeInteger(variant.price * lots));
      var canBuy = Boolean(variant && variant.available && pieces && lotsValid);
      var error = !variant ? strings.unavailable : (!lotsValid ? strings.invalidLots : '');
      errorNode.hidden = !error;
      errorNode.textContent = error;
      lotInput.setCustomValidity(lotsValid ? '' : strings.invalidLots);
      buttons.forEach(function (button) { button.disabled = !canBuy; });
      if (paymentButton) paymentButton.style.display = canBuy ? '' : 'none';

      if (pieces) {
        priceRoot.querySelector('[data-bulk-unit-price]').textContent = money(variant.price / pieces);
        var compare = priceRoot.querySelector('[data-bulk-compare-price]');
        compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price / pieces) : '';
        compare.classList.toggle('hide', !(variant.compare_at_price > variant.price));
        var summary = lotsValid ? formatTemplate(strings.orderTotal, {
          price: money(variant.price * lots), pieces: number(pieces * lots), lots: number(lots)
        }) : '';
        priceRoot.querySelector('[data-bulk-order-total]').textContent = summary;
        if (!firstSelection) statusNode.textContent = summary;
        var labelText = formatTemplate(strings.lotLabel, { pieces: number(pieces) });
        if (lotLabel) lotLabel.textContent = labelText;
        lotInput.setAttribute('aria-label', labelText);
        if (quantityBlock) {
          quantityBlock.querySelectorAll('[data-type]').forEach(function (button) {
            button.setAttribute('aria-label', button.dataset.type === 'plus' ? strings.addLot : strings.removeLot);
          });
        }
        url.searchParams.set('variant', String(variant.id));
        global.history.replaceState(global.history.state, '', url);
      } else {
        priceRoot.querySelector('[data-bulk-unit-price]').textContent = strings.unavailable;
        priceRoot.querySelector('[data-bulk-compare-price]').classList.add('hide');
        priceRoot.querySelector('[data-bulk-order-total]').textContent = '';
        statusNode.textContent = '';
      }
      firstSelection = false;
    }

    // Savon triggers jQuery changes from its swatches. Delegation runs after its
    // target handler has updated the selected variant, price, image and stock.
    $form.on('change.ilikamBulk', '.single-option-selector', synchronize);
    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-bulk-tier]')) return;
      var entry = data.variants.find(function (candidate) { return String(candidate.id) === event.target.dataset.variantId; });
      if (entry) changeOption(entry.options[quantityIndex]);
    });
    $form.on('input.ilikamBulk change.ilikamBulk', '[name="quantity"]', synchronize);
    $form.on('click.ilikamBulk', '.btn-number', function () { global.setTimeout(synchronize, 0); });
    form.addEventListener('submit', function (event) {
      synchronize();
      var entry = data.variants.find(function (candidate) {
        return selectors.every(function (selector, index) { return selector.value === candidate.options[index]; });
      });
      if (!entry || !entry.available || String(entry.id) !== variantSelect.value || !lotInput.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        errorNode.hidden = false;
        errorNode.textContent = entry ? strings.invalidLots : strings.unavailable;
      }
    }, true);

    function selectVariant(id) {
      var entry = data.variants.find(function (candidate) { return String(candidate.id) === String(id); });
      if (!entry) return false;
      selectors.forEach(function (selector, index) { selector.value = entry.options[index]; });
      changeOption(entry.options[quantityIndex]);
      return true;
    }

    global.addEventListener('popstate', function () {
      if (!root.isConnected) return;
      url = new URL(global.location.href);
      selectVariant(url.searchParams.get('variant') || root.dataset.selectedVariant);
    });
    global.addEventListener('pageshow', function (event) {
      if (event.persisted && root.isConnected) synchronize();
    });

    var nativeWrapper = quantitySelect.closest('.selector-wrapper');
    if (nativeWrapper) nativeWrapper.classList.add('bulk-native-quantity');
    var nativeSwatch = form.querySelector('.swatch[data-option-index="' + quantityIndex + '"]');
    if (nativeSwatch) nativeSwatch.classList.add('bulk-native-quantity');
    form.classList.add('bulk-unit-pricing-ready');
    root.dataset.initialized = 'true';
    root.hidden = false;
    lotInput.setAttribute('inputmode', 'numeric');
    lotInput.setAttribute('pattern', '[1-9][0-9]*');
    if (!selectVariant(url.searchParams.get('variant') || root.dataset.selectedVariant)) synchronize();
  }

  function initializeAll(scope) {
    scope.querySelectorAll('[data-bulk-unit-pricing]').forEach(initialize);
    scope.querySelectorAll('[data-bulk-cart-pricing]').forEach(function (node) {
      if (global.IlikamUnitPricing) return;
      var row = node.closest('.cart__row');
      var input = row ? row.querySelector('input[name="updates[]"]') : null;
      if (input) input.setAttribute('aria-label', formatTemplate(strings.lotLabel, {
        pieces: number(Number(node.dataset.piecesPerLot))
      }));
    });
  }

  global.jQuery(function () { initializeAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
}(typeof window === 'undefined' ? globalThis : window));
